module.exports = __webpack_public_path__ + "static/Apercu-Mono-Pro-Bold-31b771e265c95b65abcedffcd81f6434.otf";